import { appFetch } from './fetch';
import host from './host';
import auth from './auth';

export const getFixes  = async () => {
    const url = `${host}/fixes/get_all`;
    return await appFetch({ url, auth: auth.getToken(), method: 'GET' });
};

export const createFix = async data => {
    const url = `${host}/fix/create`;
    return await appFetch({ url, auth: auth.getToken(), body: JSON.stringify(data), method: 'POST' })
}

export const updateFix = async (id, data) => {
    const url = `${host}/fix/update/${id}`;
    return await appFetch({ url, auth: auth.getToken(), body: JSON.stringify(data), method: 'PUT' })
}

export const getInfoFixes  = async () => {
    const url = `${host}/fixes/get_types`;
    return await appFetch({ url, auth: auth.getToken(), method: 'GET' });
};
